/* eslint-disable indent */
/* global dataLayer */
/* eslint-disable object-shorthand */
/**
 * Number.isInteger Polyfill for IE fix
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger#Polyfill
 */
Number.isInteger =
  Number.isInteger ||
  function isInteger(value) {
    return (
      typeof value === 'number' &&
      // eslint-disable-next-line no-restricted-globals
      isFinite(value) &&
      Math.floor(value) === value
    );
  };

((window, document) => {
  /**
   * API URL's
   */
  const AJAX_MBS_URL = '/content/api/ajax_mbs_search.p';
  const AJAX_PS_URL = '/content/api/ajax_payment_services.p';
  const AJAX_ECOMM_SERVICE = '/content/api/ajax_ecomm_services.p';

  /**
   * Set the regex for last hyphen
   */
  const regexLastHyphen = /-\d+$/;

  /**
   * Check if we are on the reserve it now checkout page
   * @type {boolean}
   */
  let isReserveItNowCheckout;
  const isApplyForFinancePage = window.location.pathname.includes('apply-for-finance');

  // Get the reference to the existing quote
  let savedQuote =
    window.existingQuote && window.existingQuote.savedQuoteResult
      ? window.existingQuote.savedQuoteResult
      : null;
  // Get the reference to the order details
  const orderDetail =
    window.orderDetails && window.orderDetails.orderDetail ? window.orderDetails.orderDetail : null;

  // Get the dataLayer object
  window.dataLayer = window.dataLayer || [];

  /**
   * Get the ecomm form nav items in order to populate the stepper nav
   * @param {boolean} isCashDeal If the quote deal is cash deal
   */
  function getEcommFormNavItems(isCashDeal = false) {
    const navItems = [
      {
        id: 'js-summary-step',
        title: 'Order Summary',
        paths: ['/order-summary/'],
        step: 1,
      },
      {
        id: 'js-checkout-step',
        title: 'Checkout',
        paths: ['/checkout/'],
        step: 2,
      },
      {
        id: 'js-checkout-payment-step',
        title: 'Payment',
        paths: ['/checkout-payment/'],
        step: 4,
      },
      {
        id: 'js-finance-step',
        title: 'Finance Application',
        paths: ['/apply-for-finance/'],
        step: 3,
      },
      {
        id: 'js-confirmation-step',
        title: 'Order Confirmation',
        paths: ['/order-confirmation/'],
        step: 4,
      },
    ];

    return isCashDeal ? navItems.filter((item) => item.title !== 'Finance Application') : navItems;
  }

  /**
   * Get the nav items for reserve it now checkout
   */
  function getReserveItNowItems() {
    return [
      {
        id: 'js-details-step',
        title: 'Your details',
        paths: ['/reserve/'],
      },
      {
        id: 'js-checkout-payment-step',
        title: 'Payment',
        paths: ['/checkout/'],
      },
      {
        id: 'js-checkout-confirmation-step',
        title: 'Confirmation',
        paths: ['/checkout-confirmation/'],
      },
    ];
  }

  function getProductDetails(quote) {
    return {
      name: quote.Quote.VehicleDsc,
      id: quote.Quote.VehicleDetail.vcj_stock_ref,
      price: quote.Quote.VehiclePrice,
      category: 'Used Car',
      variant: quote.Quote.VehicleDetail.vcj_ext_colour,
      quantity: 1,
    };
  }

  function ecommerceTracking(step, option) {
    try {
      // Push google ecommerce data layer (Simon)
      window.dataLayer.push({
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: {
              step,
              option,
            },
            products: [getProductDetails(savedQuote)],
          },
        },
      });
    } catch (err) {
      console.warn('ecommerceTracking', err);
    }
  }

  /**
   * Check if the passed item is active based on the locations pathname
   * @param {object} navItem The nav item to check
   */
  function isActiveStep(navItem, receiptType) {
    for (let i = 0, len = navItem.paths.length; i < len; i += 1) {
      if (window.location.pathname.includes(navItem.paths[i]) && receiptType !== 'RESERVE_IT_NOW') {
        ecommerceTracking(navItem.step, savedQuote.custFinanceSts);
        return true;
      }
    }

    return false;
  }

  /**
   * A wrapper for generating templates with template literals
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
   * @param {string[]} strings The strings array of the template literals
   * @param {any[]} keys The values passed in
   * @returns {() => string} The returned function to be used for creating templates
   * @example
   * var t1Closure = template`${0}${1}${0}!`;
   * t1Closure('Y', 'A');  // "YAY!"
   * var t2Closure = template`${0} ${'foo'}!`;
   * t2Closure('Hello', {foo: 'World'});  // "Hello World!"
   */
  function template(strings, ...keys) {
    return function generateTemplate(...values) {
      const dict = values[values.length - 1] || {};
      const results = [strings[0]];
      for (let i = 0, len = keys.length; i < len; i += 1) {
        const value = Number.isInteger(keys[i]) ? values[keys[i]] : dict[keys[i]];
        results.push(value, strings[i + 1]);
      }
      return results.join('');
    };
  }

  /**
   * Push a checkout step object google dataLayer analytics
   * @param {string} step The step title of the page
   * @param {string} event The event name to push
   */
  function checkoutTracking(step, event) {
    // Push custom event to the data layer (Nathan)
    window.dataLayer.push({
      event,
      checkoutSteps: {
        step,
      },
    });
  }

  /**
   * Push a checkout step object google dataLayer analytics to
   * debug multiple event issue firing - SB - 24/01/22
   * @param {string} step The step title of the page
   * @param {string} orderId The order Id to push
   */
  function debugTracking(step, orderId) {
    window.dataLayer.push({
      event: 'ecommerce_epdq',
      checkout_step: step,
      transactionID: orderId,
    });
  }

  /**
   * Convert a number with commas
   * @param {number|string} num The number to convert
   * @returns {string}
   */
  function numberWithCommas(num) {
    const parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    if (parts[1]) {
      parts[1] = parts[1].slice(0, 2);
      parts[1] = parts[1].replace(/00$/, '');
    }

    return parts[1] && parts[1] !== '' ? parts.join('.') : parts[0];
  }

  /**
   * Convert a number to GBP currency
   * @param {string|number} num The number to convert
   */
  function gbpCurrency(num) {
    return `&pound;${numberWithCommas(num)}`;
  }

  class SectionItem {
    /**
     * Create a section item for using it to the template
     * @param title The title of the item
     * @param value The value of the item
     * @param isCurrency If the value is a currency
     * @param tooltip The tooltip to add to the items (optional)
     */
    constructor(title, value, isCurrency = true, tooltip = '') {
      tooltip =
        tooltip !== ''
          ? `<span class="tooltip tooltip--top-center">
        <i class="fal fa-info-circle" aria-hidden="true"></i>
        <div class="tooltip__content tooltip__content--thin">
          <p class="tooltip__text text-size--smaller font--regular">
            ${tooltip}
          </p>
        </div>
      </span>`
          : '';

      this.title = title + (tooltip !== '' ? tooltip : '');
      this.value = isCurrency ? gbpCurrency(value) : numberWithCommas(value);
    }
  }

  function sessionCheck() {
    window.SessionCheck.checkSession(AJAX_MBS_URL, 'check')
      .then((res) => {
        const data = res.myData;
        if (data.myResultData[0].sessionSts === 'SECURE') {
          window.Cookie.get('mcSess').split('-');
        } else {
          // eslint-disable-next-line no-unused-expressions
          [null, null];
        }
      })
      .catch((err) => {
        window.vm.debug.error(err);
      });
  }

  function extendSessionExpiry() {
    window.SessionCheck.checkSession(AJAX_MBS_URL, 'extend')
      .then(() => {})
      .catch((err) => {
        window.vm.debug.error(err);
      });
  }

  /**
   * Init the session checks
   */
  function initSessionChecks() {
    let idleTime = 0;
    let keyPressEventCount = 0;
    let mouseOverEventCount = 0;
    let lastCheckTime;
    /**
     *  Get the first time on the init
     */
    // const firstCheckTime = Date.now();

    sessionCheck();

    // Check session when window is getting focused
    window.addEventListener('focus', sessionCheck.bind(this));

    window.setInterval(() => {
      idleTime += 1;
      if (idleTime > 14) {
        sessionCheck();
      }
    }, 60000);

    /**
     * On mouseenter, get the first time and extend the session
     * After the first session extend, only allow it again after a minute
     * of the last check to keep the api calls down
     */
    document.addEventListener('mouseenter', () => {
      const currentCheckTime = Date.now();
      mouseOverEventCount += 1;

      if (mouseOverEventCount === 1) {
        extendSessionExpiry();
        lastCheckTime = Date.now();
      }

      if (currentCheckTime - lastCheckTime > 60000) {
        extendSessionExpiry();
        lastCheckTime = Date.now();
      }

      /**
       * Reset the idle time
       */
      idleTime = 0;
    });

    /**
     * On keypress, get the first time and extend the session
     * After the first session extend, only allow it again after a minute
     * of the last check to keep the api calls down
     */
    window.addEventListener('keypress', () => {
      const currentCheckTime = Date.now();
      keyPressEventCount += 1;

      if (keyPressEventCount === 1) {
        extendSessionExpiry();
        lastCheckTime = Date.now();
      }

      if (currentCheckTime - lastCheckTime > 60000) {
        extendSessionExpiry();
        lastCheckTime = Date.now();
      }
      /**
       * Reset the idle time
       */
      idleTime = 0;
    });
  }

  function getOptionAccessoryPrice(options) {
    return options
      .reduce((total, option) => {
        if (option.Chosen === 'Yes') {
          const cashPrice = option.CashPrice
            ? parseFloat(option.CashPrice.replace('\u00A3', ''))
            : 0;
          const cost = option.Cost ? parseFloat(option.Cost.replace('\u00A3', '')) : 0;

          // Add CashPrice if present, otherwise handle Cost, setting total to 0 if 'Free'
          total += cashPrice || (option.Cost === 'Free' ? 0 : cost);
        }
        return total;
      }, 0)
      .toFixed(2);
  }

  /**
   * Get the vehicle element required for sticky position when there are no ECOMM options
   */
  function getVehicleElementsStd() {
    return {
      tileContainer: document.querySelector('.js-std-vehicle-container') || false,
    };
  }

  /**
   * Get the vehicle elements required for binding the data
   */
  function getVehicleElements() {
    return {
      tileContainer: document.querySelector('.js-vehicle-container') || false,
      image: document.querySelector('.js-vehicle-img') || false,
      body: document.querySelector('.js-vehicle-body') || false,
      desc: document.querySelector('.js-vehicle-desc') || false,
      link: document.querySelector('.js-vehicle-link') || false,
      quoteExpired: document.querySelector('.js-quote-expired') || false,
      quoteUnavailable: document.querySelector('.js-quote-unavailable') || false,
      quoteDetailsContainer: document.querySelector('.js-details-container') || false,
      spinner: document.querySelector('.js-spinner') || false,
      header: document.querySelector('.site-nav-container') || false,
      detailsToggler: document.querySelector('.js-toggle-details') || false,
      mobileDesc: document.querySelector('.js-mobile-desc') || false,
    };
  }

  function getVehicleBodySectionItems(items) {
    const vehicleSectionItemsTemplate = template`
      <div class="xs-col-8">
        ${'title'}
      </div>
      <div id="${'id'}" class="xs-col-4 text-align--right font--bold">
        ${'value'}
      </div>
    `;

    let result = '';

    for (let i = 0, len = items.length; i < len; i += 1) {
      const itemID = items[i].title.includes('APR') ? 'APR' : '';
      result += vehicleSectionItemsTemplate({
        title: items[i].title,
        value: items[i].value,
        id: itemID,
      });
    }

    return result;
  }

  function getVehicleQuoteRefSection() {
    const quoteRef = document.querySelector('#quoteRef');

    if (!quoteRef) {
      return '';
    }

    const vehicleSectionQuoteRefTemplate = template`
      <p class="result-tile__summary">
        Quote Reference Number: <strong>${'ref'}</strong>
      </p>
    `;

    const result = vehicleSectionQuoteRefTemplate({
      ref: quoteRef.textContent,
    });

    return result;
  }

  function generateVehicleBodySection(items, sectionClasses = '', isPrice = true) {
    const vehicleSectionTemplate = template`
      <div class="section--x-small ${0}">
        <div class="row row--no-margin">
          ${1}
        </div>
      </div>
    `;

    const getSectionFunc = isPrice
      ? getVehicleBodySectionItems(items)
      : getVehicleQuoteRefSection();

    return vehicleSectionTemplate(sectionClasses, getSectionFunc);
  }

  function getTotalCostSection(quote) {
    const costSectionItems = [];

    // If has part ex
    if (quote.Quote.PartEx.PartExSts === 'HasPartEx') {
      const detailsContainer = document.querySelector('.js-details-container');
      // const partExBtn = document.querySelector('.js-go-to-part-ex-btn');

      if (detailsContainer) {
        detailsContainer.classList.add('deal-has-part-ex');
      }
    }

    // Check if it is a cash deal or finance deal
    if (quote.isCashDeal === 'Yes') {
      if (quote.Quote.PartEx.PartExSts === 'HasPartEx') {
        costSectionItems.push(
          new SectionItem('Part exchange value', `${quote.Quote.PartEx.PartExEquityVal}`),
        );
      }

      costSectionItems.push(new SectionItem('Total checkout price', quote.Quote.CheckOutAmount));
    } else if (quote.Quote.PCPAPR || quote.Quote.HPAPR) {
      // Push cash price
      costSectionItems.push(new SectionItem('Cash price', quote.Quote.CashPrice));

      if (quote.Quote.PartEx.PartExSts === 'HasPartEx') {
        costSectionItems.push(
          new SectionItem('Part exchange value', `${quote.Quote.PartEx.PartExEquityVal}`),
        );
      }

      costSectionItems.push(
        new SectionItem(
          'Total amount payable',
          quote.Quote.PCPAPR ? quote.Quote.PCPAPR.TotAmntPayable : quote.Quote.HPAPR.TotAmntPayable,
        ),
      );
    }

    return generateVehicleBodySection(costSectionItems, 'section--padding-top-only');
  }

  function getHPPCPSection(quote) {
    const quoteSectionClasses = 'section--border-bottom text--dark-grey';
    const quoteSectionItems = [];
    const financeTypeIsPCP = quote?.custFinanceSts === 'PCPAPR';

    // Push monthly payments
    quoteSectionItems.push(
      new SectionItem('Monthly payment', quote.Quote[quote.custFinanceSts].MonthlyPayment),
    );

    // Push deposit
    quoteSectionItems.push(new SectionItem('Deposit', quote.Quote.Deposit));

    // Push term
    quoteSectionItems.push(
      new SectionItem('Term', `${quote.Quote[quote.custFinanceSts].Term} months`, false),
    );

    // Push annual mileage
    if (quote.Quote.PCPAPR && financeTypeIsPCP) {
      quoteSectionItems.push(new SectionItem('Annual mileage', quote.Quote.AnnualMileage, false));
    }

    const APR = new SectionItem(
      'Representative APR',
      `${quote.Quote[quote.custFinanceSts].APR}`,
      false,
    );

    APR.value += '%';

    quoteSectionItems.push(APR);

    return generateVehicleBodySection(quoteSectionItems, quoteSectionClasses);
  }

  function getVehicleDescription(quote) {
    const vehicleDescTemplate = template`
        <div class="section--x-small section--border-bottom hide--tablet-down">
        <h4 class="line-height--small">
          ${'desc'}
        </h4>
        <div class="row row--no-margin text--dark-grey">
          ${0}
        </div>
        </div>
      `;

    return vehicleDescTemplate(
      getVehicleBodySectionItems([new SectionItem('Vehicle Price', quote.Quote.VehiclePrice)]),
      {
        desc: quote.Quote.VehicleDsc,
      },
    );
  }

  function generateVehicleDetailsBody(quote) {
    // Store the details body results
    let bodyResult = '';

    const moneyGuarantee = document.querySelector('.js-money-guarantee');
    if (
      moneyGuarantee &&
      quote.Quote.VehicleDetail &&
      quote.Quote.VehicleDetail.vcj_typ === 'lcv'
    ) {
      moneyGuarantee.style.display = 'none';
    }

    // Add the Vehicle description
    bodyResult += getVehicleDescription(quote);

    if (!isReserveItNowCheckout) {
      // Check if the vehicle has HP/PCP
      if (quote.Quote.PCPAPR || quote.Quote.HPAPR) {
        bodyResult += getHPPCPSection(quote);
      }

      // Get delivery and accessories costs
      bodyResult += generateVehicleBodySection(
        [
          new SectionItem('Accessories', getOptionAccessoryPrice(quote.Quote.Options)),
          new SectionItem('Delivery', getOptionAccessoryPrice(quote.Quote.DeliveryOptions)),
          new SectionItem(
            'Road tax',
            numberWithCommas(quote.Quote.Rfl.Price),
            true,
            quote.Quote.Rfl.Description,
          ),
        ],
        'section--border-bottom text--dark-grey',
      );

      // Get total cost
      bodyResult += getTotalCostSection(quote);

      bodyResult += generateVehicleBodySection(null, 'section--padding-top-only', false);
    } else {
      bodyResult += generateVehicleBodySection([
        new SectionItem('Reservation fee', quote.Quote.VehicleDetail.vcj_reservation_fee, false),
      ]);
      bodyResult += `<p><i class="fas fa-map-marker-alt" aria-hidden="true"></i> ${quote.Quote.VehicleDetail.vcj_location}</p>`;
    }

    return bodyResult;
  }

  function handleExpiredQuote(elements) {
    if (elements.quoteDetailsContainer && elements.quoteExpired) {
      elements.desc.textContent = savedQuote.Quote.VehicleDsc;
      elements.link.setAttribute('href', savedQuote.Quote.VehicleDetail.vcj_vehicle_url);
      elements.quoteDetailsContainer.classList.add('hide__default');
      elements.quoteExpired.classList.remove('hide__default');
    }
  }

  function handleStickyPosition(isStdVehContainer) {
    // Choose correct element to be sticky
    const { tileContainer: vehicleContainer } = isStdVehContainer
      ? getVehicleElementsStd()
      : getVehicleElements();

    if (!vehicleContainer) {
      return;
    }

    // Get the container height
    const containerHeight = vehicleContainer.getBoundingClientRect().height;
    const containerTop = vehicleContainer.offsetTop;

    // Get the parent element and the height/top of it
    const { parentElement } = vehicleContainer;
    const { y: parentTop, height: parentHeight } = parentElement.getBoundingClientRect();

    const windowTop = Math.round(window.pageYOffset);
    const maxWindowTop = parentTop + windowTop;

    const maxContainerTop = Math.round(Math.abs(parentHeight - containerHeight - 20));

    // If the window has scrolled above the container
    if (windowTop < maxWindowTop || window.innerWidth < 880 || parentHeight <= containerHeight) {
      vehicleContainer.removeAttribute('style');
      return;
    }

    // If the window has scrolled bellow the container
    if (windowTop > maxWindowTop) {
      // If the window has scrolled above the max container top
      if (windowTop - maxWindowTop < maxContainerTop) {
        vehicleContainer.setAttribute(
          'style',
          `position: absolute; top: ${Math.abs(parentTop)}px;`,
        );
      } else if (containerTop !== maxContainerTop) {
        // If the container is not set to the max container top when
        // the window is scrolling bellow the parent height
        vehicleContainer.setAttribute('style', `position: absolute; top: ${maxContainerTop}px;`);
      }
    }
  }

  /**
   * Handle the page views for the data layers analytics
   * @param {string} pathname The window's location path
   */
  function handlePageView(pathname) {
    let event = '';

    if (savedQuote) {
      event = savedQuote.isCashDeal === 'Yes' ? 'cashPurchaseStep' : 'financeStep';
    }

    switch (true) {
      case pathname.includes('/order-summary/'):
        checkoutTracking('orderSummary', event);
        break;
      case pathname.includes('/apply-for-finance/'):
        checkoutTracking('financeApplication', event);
        if (orderDetail) {
          debugTracking('financeApplication', orderDetail.orderId);
        }
        break;
      case pathname.includes('/checkout/'):
        checkoutTracking('checkout', event);
        if (orderDetail) {
          debugTracking('payment', orderDetail.orderId);
        }
        break;
      case pathname.includes('/checkout-confirmation/'):
        checkoutTracking('checkoutConfirmation', event);
        break;
      default:
        console.warn('No tracking fired');
        break;
    }
  }

  /**
   * Get the quotes of the customer
   * @param {string} quoteId The quote's id
   */
  function getQuote(quoteId) {
    if (typeof quoteId === 'string' && quoteId !== '') {
      const URI = `${AJAX_ECOMM_SERVICE}?Action=GetQuotes&QuoteId=${quoteId}`;
      // const URI = '/js/MyQuotesJSON.json';

      return axios.get(URI).then(({ data }) => {
        if (typeof data !== 'string' && data.getQuotes && data.getQuotes.length) {
          return data.getQuotes[0];
        }
        throw new Error(`Quote for quoteId: ${quoteId} was not found.`);
      });
    }

    return Promise.resolve(null);
  }

  /**
   * Call the ecomm services on the enquire page
   * @param {object} financeParams the finance params object from the session storage
   */
  function getFinance(financeParams) {
    // Get the franchis quote id input from the form
    const quoteIdInput = document.getElementById('Q634');

    // Add the quote id value to the input
    if (quoteIdInput && quoteIdInput !== null) {
      quoteIdInput.value = financeParams.QuoteId;
    }

    // Build the URL with the params
    const URI =
      `${AJAX_ECOMM_SERVICE}?Action=FinanceCalc&QuoteId=${financeParams.QuoteId}` +
      `&StockRef=${financeParams.StockRef}&SpecRef=${financeParams.SpecRef}&AnnualMileage=${financeParams.AnnualMileage}` +
      `&Term=${financeParams.Term}&TermPCP=${financeParams.TermPCP}&TermHP=${financeParams.TermHP}&dealDeposit=${financeParams.dealDeposit}` +
      `&extras=${financeParams.extras}&delivery=${financeParams.delivery}&cashSelected=${financeParams.cashSelected}&financeTypeSelected=` +
      `${financeParams.financeTypeSelected}&quoteCalcTime=${financeParams.quoteCalcTime}`;

    return axios.get(URI).then(({ data }) => {
      if (typeof data !== 'string' && data) {
        return data;
      }
      throw new Error(`Quote for quoteId: ${financeParams.QuoteId} was not found.`);
    });
  }

  function initlaizeFormNav(quote) {
    const formNavContainer = document.querySelector('.js-form-nav');

    // Store the form nav items template and if the template should have the item ticked
    let formNavItemsTemplate = '';
    let isTicked = false;

    // Create a ul element to contain the nav
    const navList = document.createElement('ul');
    navList.className = 'form-nav form-nav--small';

    const formNavItems = isReserveItNowCheckout
      ? getReserveItNowItems()
      : getEcommFormNavItems(quote.isCashDeal === 'Yes');

    // Loop through the nav items and generate the item template
    for (let i = formNavItems.length - 1; i >= 0; i -= 1) {
      const isActive = isActiveStep(formNavItems[i], quote.receiptType);

      formNavItemsTemplate = `
        <li class="form-nav__item${isActive || isTicked ? ' is-active' : ''} ${formNavItems[i].id}">
          <div class="nav-item__step">
            <i class="far fa-check nav-item__step-icon${
              isTicked ? '' : ' hide__default'
            }" style="font-size: 1.2em;"></i>
            <span class="nav-item__step-number${isTicked ? ' hide__default' : ''}">${i + 1}</span>
          </div>
          <div class="nav-item__title">
            ${formNavItems[i].title}
          </div>
        </li>
      ${formNavItemsTemplate}`;

      if (!isTicked && isActive && i > 0) {
        isTicked = true;
      }
    }

    // Add the form nav items
    navList.innerHTML = formNavItemsTemplate;

    if (formNavContainer) {
      formNavContainer.appendChild(navList);
    }
  }

  /**
   * Handle the apply for finance page to display the
   * login screen in case of the user not being logged in
   * @param {{ [key:string]: HTMLElement }} vehicleElements The vehicle elements on the page
   */

  function handleApplyForFinancePage(vehicleElements) {
    window.SessionCheck.checkSession(AJAX_MBS_URL, 'check')
      .then((res) => {
        const data = res.myData;
        if (isApplyForFinancePage && data.myResultData[0].sessionSts === 'PUBLIC') {
          window.vm.jsImport('/js/modules/dist/login-register.js').then(() => {
            const loginRegisterContainer = document.querySelector('.js-login-register');
            vehicleElements.quoteDetailsContainer.classList.add('hide__default');
            vehicleElements.quoteUnavailable.classList.add('hide__default');
            vehicleElements.quoteExpired.classList.add('hide__default');
            loginRegisterContainer.classList.remove('hide__default');
            window.addEventListener('onLogIn', () => window.location.reload());
          });
        }
      })
      .catch((err) => {
        window.vm.debug.error(err);
      });
  }

  /**
   * Handle no deposit elements
   */
  function handleNoDepositElements() {
    const elementsToRemove = document.querySelectorAll('.js-remove-if-no-deposit');
    const elementsToShow = document.querySelectorAll('.js-show-if-no-deposit');
    const sessionQuote = sessionStorage.getItem(`financeParams${savedQuote.StockRef}`);
    const financeParams = JSON.parse(sessionQuote);
    const hasZeroDeposit = financeParams.dealDeposit === 0;
    const cashSelected = financeParams.cashSelected === true;

    if (hasZeroDeposit && !cashSelected && !isReserveItNowCheckout) {
      elementsToRemove.forEach((el) => {
        el.classList.add('hide__default');
      });
      elementsToShow.forEach((el) => {
        el.classList.remove('hide__default');
      });
    } else {
      elementsToRemove.forEach((el) => {
        el.classList.remove('hide__default');
      });
      elementsToShow.forEach((el) => {
        el.classList.add('hide__default');
      });
    }
  }

  function handleFinanceTypes() {
    try {
      if (window.parent.document.querySelector('.deal-has-part-ex')) {
        const pxEl = document.querySelector('.js-go-to-part-ex-btn');
        pxEl.classList.remove('hide__default');
      }

      if (document.querySelector('.finance-url a').getAttribute('href') !== '') {
        document.querySelector('.finance-url').classList.remove('hide__default');
        const fnEl = document.querySelectorAll('.hide--if-finance');
        fnEl.forEach((el) => {
          el.classList.add('hide__default');
        });
      } else {
        const cashEl = document.querySelectorAll('.hide--if-cash');
        cashEl.forEach((el) => {
          el.classList.add('hide__default');
        });
      }
    } catch (err) {
      console.warn('handleFinanceTypes', err);
    }
  }

  /**
   * Handle the data response
   * @param {*} data The data to append to the response
   */
  function handleDataResponse(data) {
    try {
      const orderConfirmation = document.querySelector('.js-order-confirmation');
      const confirmationFragment = new DocumentFragment();
      const confirmationDiv = document.createElement('div');
      const errorInformation = document.createElement('div');
      errorInformation.innerHTML = `

      <h4>What do I do next?</h4>

      <p>1. <strong>Check your details are correct.</strong> Once you are sure they are correct, resubmit the request by clicking the 'refresh' button on this page. Remember you have limited attempts before your card will be locked.</p>
      <p>2. <strong>Talk to one of our Click2Drive advisors.</strong> The choice to open a chat window with one of our friendly advisors will be at the bottom right of your screen, and they will be happy to help you.</p>
      <p>3. <strong>Contact your bank.</strong> If you think it is an issue that you need to discuss with your bank provider, ring them directly.</p>

      <p>There have been updates recently on how merchants and Payment Service Providers (PSPs) must offer online purchases. From 14th March 2022, all transactions must now be Strong Customer Authentication (SCA) compliant as regulated by the FCA. As a result, you would have been asked for Two-Factor Authentication (2FA) for your own security.</p>
      <p>If you cannot supply this information, we cannot complete the purchase. You may have had trouble with providing this information, in which case there are three routes to resolve this.</p>`;

      confirmationDiv.innerHTML = data;
      confirmationFragment.appendChild(confirmationDiv);
      orderConfirmation.appendChild(confirmationFragment);
      if (confirmationDiv.querySelector('.js-payment-declined-msg-container')) {
        orderConfirmation.appendChild(errorInformation);
      }
      handleFinanceTypes();
    } catch (err) {
      console.warn('handleDataResponse', err);
    }
  }

  /**
   * Handle the elements onm the checkout respone
   */
  function handleCheckoutResponse() {
    try {
      const hideIfConfirmation = document.querySelectorAll('.js-hide-if-no-dep-confirmation');
      const showIfConfirmation = document.querySelectorAll('.js-show-if-no-dep-confirmation');

      if (hideIfConfirmation) {
        hideIfConfirmation.forEach((el) => {
          el.classList.add('hide__default');
        });
      }

      if (showIfConfirmation) {
        showIfConfirmation.forEach((el) => {
          el.classList.remove('hide__default');
        });
      }

      handleFinanceTypes();
    } catch (err) {
      console.warn('handleCheckoutResponse', err);
    }
  }

  /**
   * Handle the finance/cash messaging
   */
  function handleMessages() {
    // Hide the reserve-it-now, finance-deal messages
    document.querySelector('.js-part-ex-deal').classList.add('hide__default');
    document.querySelector('.js-reserve-it-now').classList.add('hide__default');
    document.querySelector('.js-cash-deal').classList.add('hide__default');
    document.querySelector('.js-finance-deal').classList.add('hide__default');
  }

  function updateNavs() {
    const confirmStep = document.querySelector('.js-confirmation-step');
    const checkoutConfirmStep = document.querySelector('.js-checkout-confirmation-step');
    const checkoutTitle = document.querySelector('.js-checkout-heading');
    const checkoutStep = document.querySelector('.js-checkout-step');
    const checkoutPaymentStep = document.querySelector('.js-checkout-payment-step');
    if (checkoutStep) {
      checkoutStep.classList.add('is-active');
      checkoutStep.querySelector('.nav-item__step-number').classList.add('hide__default');
      checkoutStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
    }
    if (checkoutPaymentStep) {
      checkoutPaymentStep.classList.add('is-active');
      checkoutPaymentStep.querySelector('.nav-item__step-number').classList.add('hide__default');
      checkoutPaymentStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
    }
    // if the confirm step nav is present, tick it and highlight it
    if (confirmStep) {
      confirmStep.querySelector('.nav-item__step-number').classList.add('hide__default');
      confirmStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
      confirmStep.classList.add('is-active');
    }
    // if the checkout confirm step nav is present, tick it and highlight it
    if (checkoutConfirmStep) {
      checkoutConfirmStep.querySelector('.nav-item__step-number').classList.add('hide__default');
      checkoutConfirmStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
      checkoutConfirmStep.classList.add('is-active');
    }
    // Hide checkout title when payment is done
    if (checkoutTitle) {
      checkoutTitle.closest('.section--small').classList.add('hide__default');
    }

    // Hide the reserve-it-now, finance-deal messages
    handleMessages();
  }

  // Check the dom for either confirmation step type. If one is present then nav has loaded.
  function checkNavLoad() {
    const checkoutPaymentStep =
      document.querySelector('.js-confirmation-step') ||
      document.querySelector('.js-checkout-confirmation-step');
    // If nave has loaded, highlight the correct elems
    if (checkoutPaymentStep) {
      updateNavs();
    } else {
      // If they haven't yet loaded, retry after 100ms. Do this until they have loaded.
      setTimeout(checkNavLoad, 100);
    }
  }

  function checkoutConfirmationHandler(event) {
    const { orderId, paymentType } = orderDetail ?? {};
    const refreshPageButton = document.querySelector('.js-ecomm-refresh-page-btn');

    const isDevSite = window.location.hostname.indexOf('dev') > -1;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const dealRef = urlParams.get('dealRef');
    const dealHash = urlParams.get('dealHash');

    if (paymentType === 'ELAVON') {
      let responseKey;

      const ELAVON_URL = isDevSite
        ? 'https://pay.sandbox.elavonpaymentgateway.com'
        : 'https://pay.elavonpaymentgateway.com';

      // If the source origin isn't from Elavon, return
      if (event.origin !== ELAVON_URL) {
        return;
      }

      const iframe = document.querySelector('#js-checkout-iframe');
      const responseObject = event.data;
      const hasError = responseObject.includes('Error');
      const responseObjectParsed = hasError ? null : JSON.parse(responseObject);
      // const firstKey = hasError ? null : Object.keys(responseObjectParsed)[0];
      // firstKey === 'SRD' || firstKey === 'CAVV'

      // If there's an error, the response object is not available
      if (!hasError) {
        Object.entries(responseObjectParsed).forEach(([key, value]) => {
          if (key === 'RESULT') {
            responseKey = value;
          }
        });
      }

      if (responseKey || hasError) {
        if (refreshPageButton) {
          refreshPageButton.classList.add('hide__default');
        }
        // eslint-disable-next-line max-len
        axios
          .post(
            `${AJAX_PS_URL}?Action=EcommPayment${
              hasError
                ? `&dealRef=${dealRef}&dealHash=${dealHash}&orderId=${orderId}&elvnText=${event.data}`
                : ''
            }`,
            {
              ElvnMessage: !hasError ? responseObject : null,
            },
          )
          .then(({ data }) => {
            iframe?.classList.add('hide__default');
            handleDataResponse(data);
            // MDA= reponse code = successful transaction
            if (responseKey && responseKey === 'MDA=') {
              // Ecommerce tracking
              try {
                window.dataLayer.push({
                  event:
                    savedQuote.receiptType === 'RESERVE_IT_NOW'
                      ? 'reserveItNowComplete'
                      : 'purchaseComplete',
                  ecommerce: {
                    purchase: {
                      actionField: {
                        id: orderDetail.orderId.replace(regexLastHyphen, ''),
                        affiliation:
                          savedQuote.receiptType === 'RESERVE_IT_NOW'
                            ? 'Reserve it now'
                            : 'BSM Buy Online',
                        revenue:
                          savedQuote.receiptType === 'RESERVE_IT_NOW'
                            ? savedQuote.Quote.VehiclePrice
                            : savedQuote.Quote.CheckOutAmount,
                        tax: '',
                        shipping:
                          savedQuote.receiptType === 'RESERVE_IT_NOW'
                            ? ''
                            : savedQuote.Quote.DeliveryOptions.filter(
                                (el) => el.Chosen === 'Yes',
                              )[0].Cost,
                      },
                      products: [getProductDetails(savedQuote)],
                    },
                  },
                });

                // Debug tracking to investigate multiple data layer events fired - SB - 24/01/22
                debugTracking(
                  savedQuote.receiptType === 'RESERVE_IT_NOW'
                    ? 'reserveItNowComplete'
                    : 'purchaseComplete',
                  orderDetail.orderId,
                );

                ecommerceTracking(4, savedQuote.custFinanceSts);

                // Custom tracking
                window.dataLayer.push({
                  event: `${savedQuote.custFinanceSts.toLowerCase()}Purchase`,
                  checkoutPurchase: {
                    saleValue: savedQuote.Quote.CheckOutAmount,
                  },
                });
              } catch (err) {
                console.warn(err);
              }

              if (savedQuote.receiptType === 'RESERVE_IT_NOW') {
                try {
                  let reservationFee = savedQuote.Quote.VehicleDetail.vcj_reservation_fee;
                  if (reservationFee.includes('&pound;')) {
                    reservationFee = reservationFee.replace('&pound;', '£');
                  }

                  const sessionKey = window.sessionStorage.getItem('_reserveOnlineUserDetails');
                  let userData = {
                    custEmail: '',
                    custTel1: '',
                  };

                  if (sessionKey) {
                    const userDetails = JSON.parse(sessionKey);
                    userData = {
                      custEmail: userDetails.custEmail,
                      custTel1: userDetails.custTel1,
                    };
                  }

                  dataLayer.push({
                    event: 'reserveConfirmation',
                    reserveValue: reservationFee,
                    userData: userData,
                  });
                } catch (err) {
                  console.warn('No reservation fee', err);
                }
              }
            } else {
              // Unsuccsessful transaction
              // Debug tracking to investigate multiple data layer events fired - SB - 24/01/22
              debugTracking(
                savedQuote.receiptType === 'RESERVE_IT_NOW'
                  ? 'reserveItNowUnsuccessful'
                  : 'purchaseUnsuccsessful',
                orderDetail.orderId,
              );
            }
          })
          .catch((err) => {
            console.warn(err);
          });

        updateNavs();
        checkNavLoad();
      }
    }
  }

  function dataLayerTracking() {
    const { paymentResponse, paymentType } = orderDetail ?? {};
    // Check if url has error_code  parameter
    const hasErrorCodeInUrl = window.location.href.includes('error_code');

    if (paymentResponse === 'yes' && paymentType === 'BARCLAYS') {
      try {
        let eventName;
        if (hasErrorCodeInUrl) {
          eventName = 'purchaseUnsuccessfulDueToErrorCode';
        } else if (savedQuote?.receiptType === 'RESERVE_IT_NOW') {
          eventName = 'reserveItNowComplete';
        } else {
          eventName = 'purchaseComplete';
        }

        window.dataLayer.push({
          event: eventName,
          ecommerce: {
            purchase: {
              actionField: {
                id: orderDetail.orderId.replace(regexLastHyphen, ''),
                affiliation:
                  savedQuote.receiptType === 'RESERVE_IT_NOW' ? 'Reserve it now' : 'BSM Buy Online',
                revenue:
                  savedQuote.receiptType === 'RESERVE_IT_NOW'
                    ? savedQuote.Quote.VehiclePrice
                    : savedQuote.Quote.CheckOutAmount,
                tax: '',
                shipping:
                  savedQuote.receiptType === 'RESERVE_IT_NOW'
                    ? ''
                    : // eslint-disable-next-line max-len
                      savedQuote.Quote.DeliveryOptions.filter((el) => el.Chosen === 'Yes')[0].Cost,
              },
              products: [getProductDetails(savedQuote)],
            },
          },
        });

        // Debug tracking to investigate multiple data layer events fired - SB - 24/01/22
        debugTracking(
          savedQuote.receiptType === 'RESERVE_IT_NOW' ? 'reserveItNowComplete' : 'purchaseComplete',
          orderDetail.orderId,
        );

        ecommerceTracking(4, savedQuote.custFinanceSts);

        // Custom tracking
        window.dataLayer.push({
          event: `${savedQuote.custFinanceSts.toLowerCase()}Purchase`,
          checkoutPurchase: {
            saleValue: savedQuote.Quote.CheckOutAmount,
          },
        });
      } catch (err) {
        console.warn(err);
      }

      if (savedQuote.receiptType === 'RESERVE_IT_NOW') {
        try {
          let reservationFee = savedQuote.Quote.VehicleDetail.vcj_reservation_fee;
          if (reservationFee.includes('&pound;')) {
            reservationFee = reservationFee.replace('&pound;', '£');
          }

          const sessionKey = window.sessionStorage.getItem('_reserveOnlineUserDetails');
          let userData = {
            custEmail: '',
            custTel1: '',
          };

          if (sessionKey) {
            const userDetails = JSON.parse(sessionKey);
            userData = {
              custEmail: userDetails.custEmail,
              custTel1: userDetails.custTel1,
            };
          }

          dataLayer.push({
            event: 'reserveConfirmation',
            reserveValue: reservationFee,
            userData: userData,
          });
        } catch (err) {
          console.warn('No reservation fee', err);
        }
      }
    }
  }

  function handleEnquiryPage(financeParams) {
    // Get the interested radio button elements
    const interestedRadioElements = {
      PCPAPR: document.querySelector('input#Q635_0001'),
      HPAPR: document.querySelector('input#Q635_0002'),
      Cash: document.querySelector('input#Q635_0003'),
    };

    if (!savedQuote || !savedQuote.Quote || !financeParams) {
      return;
    }

    const hasFinanceOptions =
      savedQuote.Quote.VehicleFinanceSts.HPAPR ||
      savedQuote.Quote.VehicleFinanceSts.PCPAPR ||
      savedQuote.Quote.VehicleFinanceSts.Cash;
    const radioButtonContainer = document.querySelector('.js-show-if-monthly-price');

    // Loop through them to add which on the custoemr is intersted with
    Object.entries(savedQuote.Quote.VehicleFinanceSts).forEach(([key, value]) => {
      const radioElement = interestedRadioElements[key];

      if (radioElement) {
        if (!value) {
          radioElement.parentElement.style.display = 'none';
        }
        radioElement.checked = false;
      }
    });

    if (radioButtonContainer && hasFinanceOptions) {
      radioButtonContainer.classList.remove('hide__default');
    }

    // If finance is selected, select by default the selected finance
    if (
      financeParams.financeTypeSelected in interestedRadioElements &&
      interestedRadioElements[financeParams.financeTypeSelected]
    ) {
      interestedRadioElements[financeParams.financeTypeSelected].checked = true;
    } else if (financeParams.cashSelected && interestedRadioElements.Cash) {
      // If cash is selected
      interestedRadioElements.Cash.checked = true;
    } else {
      // If no finance or cash is selected
      Object.keys(interestedRadioElements).forEach((btnKey) => {
        const radioElement = interestedRadioElements[btnKey];
        if (radioElement) {
          radioElement.checked = true; // Check the radio button
        }
      });
    }
  }

  /**
   * Track monthly price session if the tracking object is set from ecomm app
   */
  function trackMonthlyPriceSession() {
    const sessionTrackingObject = sessionStorage.getItem('trackingObject');

    if (sessionTrackingObject !== null) {
      const trackingObject = JSON.parse(sessionTrackingObject);

      // Monthly Price Data Layer Object
      window.dataLayer.push({
        monthlyPrice: {
          deposit: trackingObject.monthlyPrice.deposit,
          term: trackingObject.monthlyPrice.term,
          mileage: trackingObject.monthlyPrice.mileage,
          hpFinance: trackingObject.monthlyPrice.hpFinance,
          pcpFinance: trackingObject.monthlyPrice.pcpFinance,
        },
      });
    }
  }

  /**
   * Handle the deposit checkout
   */
  function handleNoDepositCheckout(quoteId, dealHash) {
    const noDepositBtn = document.querySelector('.js-reserve-with-no-deposit');
    const URI = `${AJAX_ECOMM_SERVICE}?Action=ConfirmWithNilDeposit&QuoteId=${quoteId}&dealHash=${dealHash}`;

    if (noDepositBtn) {
      noDepositBtn.addEventListener('click', () => {
        const vehicleElements = getVehicleElements();

        if (vehicleElements.spinner) {
          vehicleElements.spinner.style.position = 'absolute';
          vehicleElements.spinner.classList.remove('hide__default');
        }

        axios.get(URI).then(({ data }) => {
          if (!data) {
            return data;
          }

          // If successful response
          if (data.confirm0DepositResponse) {
            handleDataResponse(data.confirm0DepositResponse.ecommPaidElvn);
            handleCheckoutResponse();

            if (vehicleElements.spinner) {
              vehicleElements.spinner.style.position = '';
              vehicleElements.spinner.classList.add('hide__default');
            }
          }

          updateNavs();
          checkNavLoad();
          return data;
        });
      });
    }
  }

  function initialize() {
    dataLayerTracking();
    const vehicleElements = getVehicleElements();

    // Check whether vehicle has any ECOMM options
    let isStdVehContainer = true;
    const stdVehicleContainer = document.querySelector('.js-std-vehicle-container');
    if (savedQuote && savedQuote.Quote) {
      const vehicleFinanceSts = Object.values(savedQuote.Quote.VehicleFinanceSts);
      for (let i = 0; i < vehicleFinanceSts.length; i += 1) {
        if (vehicleFinanceSts[i]) {
          isStdVehContainer = false;
          break;
        }
      }
    }

    // If there are no ECOMM options
    if (isStdVehContainer && stdVehicleContainer) {
      stdVehicleContainer.classList.remove('hide__default');
    } else if (savedQuote && savedQuote.Quote) {
      handleNoDepositElements();

      // Remove 0 from x.x0 on APR
      if (savedQuote.Quote.PCPAPR) {
        savedQuote.Quote.PCPAPR.APR = savedQuote.Quote.PCPAPR.APR.replace(/0$/, '');
      } else if (savedQuote.Quote.HPAPR) {
        savedQuote.Quote.HPAPR.APR = savedQuote.Quote.HPAPR.APR.replace(/0$/, '');
      }

      // Else if the quote exists
      if (document.querySelector('.js-vehicle-container')) {
        document.querySelector('.js-vehicle-container').classList.remove('hide__default');

        // If the quote has not expired
        if (savedQuote.QuoteExpired !== 'Expired' || isApplyForFinancePage) {
          vehicleElements.image.style.backgroundImage = `url('${
            savedQuote.Quote.VehicleDetail.vcj_image_results_src || savedQuote.Quote.VehicleImgUrl
          }')`;
          vehicleElements.body.innerHTML = generateVehicleDetailsBody(savedQuote);
          vehicleElements.mobileDesc.textContent = savedQuote.Quote.VehicleDsc;

          vehicleElements.detailsToggler.addEventListener('click', () => {
            // If the class was added the details having been hidden
            if (vehicleElements.body.classList.toggle('hide--tablet-down')) {
              vehicleElements.detailsToggler.textContent = 'View full details';
            } else {
              // Else the details are shown
              vehicleElements.detailsToggler.textContent = 'Hide full details';
            }
          });
        } else {
          // Else the quote expired
          handleExpiredQuote(vehicleElements);
        }

        // TODO: Should move this to the checkout file. Update the checkout title based on deal type
        const checkoutTitle = document.querySelector('.js-checkout-heading');
        if (checkoutTitle && savedQuote.receiptType !== 'RESERVE_IT_NOW') {
          checkoutTitle.textContent =
            savedQuote.custFinanceSts === 'CASH' ? '- Pay your balance' : '- Pay your deposit';

          // If deal has part ex
          if (savedQuote.Quote.PartEx.PartExSts === 'HasPartEx') {
            try {
              document.querySelector('.js-part-ex-deal').classList.remove('hide__default');
            } catch (err) {
              console.warn('Does not have part ex', err);
            }
          } else if (savedQuote.custFinanceSts !== 'CASH') {
            try {
              document.querySelector('.js-finance-deal').classList.remove('hide__default');
            } catch (err) {
              console.warn('Is CASH', err);
            }
          } else {
            try {
              const cashDealP = document.querySelector('.js-cash-deal');
              cashDealP.textContent = cashDealP.textContent.replace(
                '{vcj_typ}',
                savedQuote.Quote.VehicleDetail.vcj_typ === 'bike'
                  ? 'motorcycle'
                  : savedQuote.Quote.VehicleDetail.vcj_typ.toLowerCase(),
              );
              cashDealP.classList.remove('hide__default');
            } catch (err) {
              console.warn(err);
            }
          }
        }
      }

      if (vehicleElements.quoteDetailsContainer) {
        vehicleElements.quoteDetailsContainer.classList.remove('hide__default');
      }

      initlaizeFormNav(savedQuote);

      // Handle the reserve with no deposit functionality
      handleNoDepositCheckout(savedQuote.Quote.QuoteId, savedQuote.Quote.dealHash);
    } else if (vehicleElements.quoteUnavailable) {
      // If the quote doesnt exist
      vehicleElements.quoteUnavailable.classList.remove('hide__default');

      if (vehicleElements.quoteDetailsContainer) {
        vehicleElements.quoteDetailsContainer.classList.add('hide__default');
      }
    }

    handleApplyForFinancePage(vehicleElements);

    // Check if the header is on the page and make it relative
    if (vehicleElements.header) {
      vehicleElements.header.style.position = 'relative';
    }

    // If the spinner is on the page hide it
    if (vehicleElements.spinner) {
      vehicleElements.spinner.classList.add('hide__default');
    }

    // Handle the page views for google analytics dataLayer
    handlePageView(window.location.pathname);

    // Check if passive option is supported to improve scrolling performance
    let passiveIfSupported = false;

    try {
      window.addEventListener(
        'test',
        null,
        Object.defineProperty({}, 'passive', {
          get() {
            passiveIfSupported = { passive: false };
            return false;
          },
        }),
      );
    } catch (err) {
      console.warn('passiveSupported', err);
    }

    // Handle the stickyPosition and add event listeners for scroll and resize
    handleStickyPosition(isStdVehContainer);
    window.addEventListener(
      'scroll',
      () => {
        handleStickyPosition(isStdVehContainer);
      },
      passiveIfSupported,
    );
    window.addEventListener(
      'resize',
      () => {
        handleStickyPosition(isStdVehContainer);
      },
      passiveIfSupported,
    );
  }

  // Create a customer session object
  // const customerSession = new CustomerSession();
  // Export customer session for global use
  // window.customerSession = customerSession;
  vm.onload(() => {
    initSessionChecks();
    window.SessionCheck.checkSession(AJAX_MBS_URL, 'check')
      .then((res) => {
        const data = res.myData;

        // Check if we are on an enquiry page
        const isEnquiryPage = /\/(request-a-callback|enquire)\//.test(window.location.pathname);
        isReserveItNowCheckout = /referrer=RESERVE_IT_NOW/i.test(window.location.search);

        const sessionQuote = sessionStorage.getItem('quote');

        // Check if the session storage has the quote object
        if (sessionQuote !== null && isEnquiryPage) {
          // Get the object
          const financeParams = JSON.parse(sessionQuote);

          trackMonthlyPriceSession();

          getFinance(financeParams)
            .then((quoteResponse) => {
              savedQuote = quoteResponse;

              handleEnquiryPage(financeParams);
              initialize();
            })
            .catch((err) => {
              vm.debug.error(err);
              initialize();
            });
        } else if (
          savedQuote === null &&
          data.myResultData[0].sessionSts === 'SECURE' &&
          orderDetail !== null
        ) {
          getQuote(orderDetail.QuoteId)
            .then((quoteResponse) => {
              savedQuote = quoteResponse;

              initialize();
            })
            .catch((err) => {
              vm.debug.error(err);
              initialize();
            });
        } else {
          initialize();
        }

        window.addEventListener('message', checkoutConfirmationHandler, false);

        // Add an event listener to the finance submitted event in
        // order to add checkmarks to the form nav items
        window.addEventListener('financeSubmitted', function financeSubmitHandler() {
          const financeStep = document.querySelector('.js-finance-step');
          const confirmationStep = document.querySelector('.js-confirmation-step');
          financeStep.querySelector('.nav-item__step-number').classList.add('hide__default');
          financeStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
          confirmationStep.classList.add('is-active');
          confirmationStep.querySelector('.nav-item__step-number').classList.add('hide__default');
          confirmationStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
          window.removeEventListener('financeSubmitted', financeSubmitHandler);
        });
      })
      .catch((err) => {
        window.vm.debug.error(err);
      });
  });
})(window, document);
